import { Component } from 'src/utils';
import template from './change-password.html';

@Component({
  controllerAs: 'changePassword',
  template
})

export default class ChangePassword {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    '$timeout',
    'toaster',
    'authService'
  ];

  constructor($scope, $ngRedux,$state, $stateParams, $timeout, toaster, authService) {
    const disconnect = $ngRedux.connect(this.mapState)(this);    
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.authService = authService;
    this.toaster = toaster;
    this.$timeout = $timeout;
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      detail: state.auth.profile,
      store: state.auth.storeDetail
    };
  }

  submit(form) {
    if (form.$invalid) {
      return;
    }
    form.error = {};
    if (!this.currentpassword) {
      form.error.message = 'Please enter current password!';
      return;
    }
    if (this.password === this.currentpassword) {
      form.error.message = 'Current password and new password are same!. Please change it!';
      return;
    }
    if (this.password === this.confirmPassword) {
      var $ctrl = this;
      $ctrl.authService.changePassword({
        password: this.password,
        currentpassword: this.currentpassword,
        userId: this.detail.userId
      }).then( data => {
        if(data.status == 200) {
        $ctrl.toaster.pop('success', 'Password changed successfully');
        }
        else {
         $ctrl.toaster.pop('success', data.statusText);
        }
        $ctrl.$timeout(() => { this.$state.go('home'); },1000);
      } ).catch(err => {
        if (err.data.errorCode === 706 || err.data.errorCode === 605) {
          form.error.message = err.data.message;
        }
        $ctrl.toaster.pop('success', 'Password failed to changed. Please Try again!');
     });
    }
    else {
      form.error.message = 'Password mismatch';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/change-password/change-password.js